<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3 p-2 bg-light border rounded">
      <div>
        <button class="btn btn-outline-secondary me-2" :disabled="page <= 1" @click="prevPage">&laquo;</button>
        <input
          type="number"
          class="form-control d-inline-block mx-2"
          style="width: 70px"
          v-model.number="inputPage"
          @change="goToPage"
          :min="1"
          :max="numPages"
        />
        <span>/ {{ numPages || '?' }}</span>
        <button class="btn btn-outline-secondary ms-2" :disabled="page >= numPages" @click="nextPage">&raquo;</button>
      </div>
      <div v-if="!pdf_ready && pdf_loading_progress < 100" style="min-width: 200px">
        <div class="progress" style="height: 20px">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: pdf_loading_progress + '%' }"
            :aria-valuenow="pdf_loading_progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ pdf_loading_progress }}%
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" v-if="pdf_error"><strong>ERROR</strong></div>
    <VuePdfEmbed
      :source="path"
      @rendered="rendered"
      @progress="progress"
      @rendering-failed="rendering_failed"
      :page="page"
      ref="pdfEmbed"
      @loaded="onLoaded"
    ></VuePdfEmbed>

    <div class="d-flex align-items-center justify-content-between mt-3 p-2 bg-light border rounded" v-if="pdf_ready">
      <div>
        <button class="btn btn-outline-secondary me-2" :disabled="page <= 1" @click="prevPage">&laquo;</button>
        <input
          type="number"
          class="form-control d-inline-block mx-2"
          style="width: 70px"
          v-model.number="inputPage"
          @change="goToPage"
          :min="1"
          :max="numPages"
        />
        <span>/ {{ numPages || '?' }}</span>
        <button class="btn btn-outline-secondary ms-2" :disabled="page >= numPages" @click="nextPage">&raquo;</button>
      </div>
      <div v-if="!pdf_ready && pdf_loading_progress < 100" style="min-width: 200px">
        <div class="progress" style="height: 20px">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: pdf_loading_progress + '%' }"
            :aria-valuenow="pdf_loading_progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ pdf_loading_progress }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: { VuePdfEmbed },
  props: ['path'],
  data() {
    return {
      pdf_error: 0,
      pdf_ready: 0,
      pdf_loading_progress: 0,
      page: 1,
      inputPage: 1,
      numPages: null,
    }
  },
  methods: {
    rendering_failed() {
      this.pdf_error = 1
    },
    rendered() {
      this.pdf_ready = 1
    },
    progress(e) {
      this.pdf_loading_progress = Math.floor((e.loaded / e.total) * 100)
    },
    prevPage() {
      if (this.page > 1) {
        this.page--
        this.inputPage = this.page
        this.pdf_ready = 0
      }
    },
    nextPage() {
      if (this.page < this.numPages) {
        this.page++
        this.inputPage = this.page
        this.pdf_ready = 0
      }
    },
    goToPage() {
      if (this.inputPage >= 1 && this.inputPage <= this.numPages && this.inputPage !== this.page) {
        this.page = this.inputPage
        this.pdf_ready = 0
      } else {
        this.inputPage = this.page
      }
    },
    onLoaded(pdf) {
      this.numPages = pdf.numPages
    },
  },
}
</script>
